module.exports = __webpack_public_path__ + "static/media/Mnemonic.f69088ed.jpg";